import { useSeo } from "@/lib/seo";
import { openCookiePreferences, useCookieBannerEnabled } from "@/lib/consent";

const CONTACT_EMAIL = "contact@destockageluminaires.fr";

export default function PrivacyPolicy() {
  useSeo("confidentialite", {
    title: "Politique de confidentialité | Déstockage Luminaires",
    description: "Comment nous utilisons vos données de navigation pour améliorer le site.",
  });
  const bannerEnabled = useCookieBannerEnabled();

  return (
    <div className="max-w-[760px] mx-auto px-6 md:px-10 py-14 md:py-20">
      <p className="text-xs uppercase tracking-[0.25em] text-gold font-medium mb-4">RGPD</p>
      <h1 className="font-serif text-3xl md:text-4xl font-medium text-ink mb-8">
        Politique de confidentialité
      </h1>

      <div className="space-y-10 text-ink/80 leading-relaxed">
        <section>
          <h2 className="font-serif text-xl text-ink mb-3">Quelles données collectons-nous ?</h2>
          <ul className="list-disc pl-5 space-y-1.5 text-sm md:text-base">
            <li>Un identifiant de session, les pages consultées et le temps passé sur le site.</li>
            <li>Votre appareil, navigateur et système d'exploitation.</li>
            <li>Votre adresse IP et une localisation approximative (pays / ville).</li>
            <li>Les produits consultés et ajoutés au panier.</li>
            <li>Si vous commandez : nom, email, adresse de livraison et de facturation.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif text-xl text-ink mb-3">Pourquoi ?</h2>
          <p className="text-sm md:text-base">
            Pour faire fonctionner votre panier et votre compte, comprendre comment le site est
            utilisé afin de l'améliorer, prévenir la fraude, et traiter vos commandes et demandes
            de service client. Nous ne vendons aucune donnée à des tiers.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl text-ink mb-3">Combien de temps les conservons-nous ?</h2>
          <p className="text-sm md:text-base">
            Les données de navigation (mesure d'audience) sont conservées 13 mois maximum. Les
            données liées à une commande sont conservées le temps requis par nos obligations
            comptables et légales.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-xl text-ink mb-3">Vos droits</h2>
          <p className="text-sm md:text-base">
            Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de
            suppression et d'opposition sur vos données. Vous pouvez aussi retirer votre
            consentement à la mesure d'audience à tout moment : votre visite reste alors
            anonyme, sans identifiant conservé d'une visite à l'autre.
          </p>
          {bannerEnabled && (
            <button
              onClick={openCookiePreferences}
              className="mt-4 text-xs uppercase tracking-[0.1em] border border-ink/20 text-ink hover:border-ink transition-colors rounded-full px-5 py-2.5"
            >
              Gérer mes préférences de cookies
            </button>
          )}
        </section>

        <section>
          <h2 className="font-serif text-xl text-ink mb-3">Nous contacter</h2>
          <p className="text-sm md:text-base">
            Pour exercer vos droits ou toute question sur vos données, écrivez-nous à{" "}
            <a href={`mailto:${CONTACT_EMAIL}`} className="underline underline-offset-2 hover:text-copper">
              {CONTACT_EMAIL}
            </a>
            .
          </p>
        </section>
      </div>
    </div>
  );
}
